import CompanyEdit from './edit';
import CompanyShow from './show';

export default {
  edit: CompanyEdit,
  show: CompanyShow,
};
